(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("harriSideBarService", HarriSideBarService);
    HarriSideBarService.$inject = ['$q', '$stateParams', 'hUser', 'userPermissions', 'hmapService', 'talentPoolDataService', '$state', 'brandServices'];

    function HarriSideBarService($q, $stateParams, hUser, userPermissions, hmapService, talentPoolDataService, $state, brandServices) {
        var self = this;
        let teamLiveBrandsListCache = {};
        let userDetailsCache = {};

        self.isAbsenceTypeTabShown = function (activeBrand, type) {
            if (activeBrand['brand_absences']) {
                return activeBrand['brand_absences'].find(function (absences) {
                    return absences['type'] === type;
                });
            }
        };

        self.canShowAbsenceRequests = function (activeBrand) {
            for (var i in activeBrand['brand_absences']) {
                var brandAbsence = activeBrand['brand_absences'][i];
                if (['CUSTOM', 'PATERNITY', 'BEREAVEMENT', 'MATERNITY', 'SHARED_PARENTAL', 'ADOPTION', 'HOLIDAY'].indexOf(brandAbsence.type) > -1) {
                    return true;
                }
            }
            return false;
        };

        self.checkGlobalTalentPoolPermission = function () {
            var defer = $q.defer();

            if (hUser.isTopLevelContext()) {
                var brandId = hmapService.getActiveBrand();

                userPermissions.getBrandPolicy(brandId)
                    .then(function (policyParser) {
                        defer.resolve(policyParser.brands(brandId).has(userPermissions.PERMISSIONS.MANAGE_TALENT_POOL_MODULE));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            } else {
                talentPoolDataService.checkTalentPoolPermissionOnEnterpriseAndChild()
                    .then(function (res) {
                        defer.resolve(res);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.checkIfApprovalFlowEnabled = function (isApprovalFlowServiceEnabled, approvalFlowsSettings, policyParser) {
            var teamlivePositionEnabled;
            var teamliveLocationPeriodEnabled;

            if (approvalFlowsSettings && approvalFlowsSettings.settings) {
                teamlivePositionEnabled = approvalFlowsSettings.settings.teamlive_position_enabled;
                teamliveLocationPeriodEnabled = approvalFlowsSettings.settings.teamlive_location_period_enabled;
            }

            return (
                isApprovalFlowServiceEnabled &&
                (
                    policyParser.brands(policyParser.ANY).has(userPermissions.PERMISSIONS.OVERRIDE_APPROVALS) ||
                    teamlivePositionEnabled ||
                    teamliveLocationPeriodEnabled
                )
            );
        };

        self.getTeamLiveBrandsList = function (enterpriseBrandId, brandId) {
            var defer = $q.defer();

            if (teamLiveBrandsListCache[enterpriseBrandId] && teamLiveBrandsListCache[enterpriseBrandId][brandId]) {
                defer.resolve(teamLiveBrandsListCache[enterpriseBrandId][brandId]);
            } else {
                GatewayTeamLiveAPI
                    .getBrandsSettingsV3(enterpriseBrandId, {brand_ids: [brandId]})
                    .then(function (brands) {
                        teamLiveBrandsListCache[enterpriseBrandId] = teamLiveBrandsListCache[enterpriseBrandId] || {};
                        teamLiveBrandsListCache[enterpriseBrandId][brandId] = brands;
                        defer.resolve(teamLiveBrandsListCache[enterpriseBrandId][brandId]);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.getMemberBasicInfo = async (brandId, userId) => {
            try {
                if (userDetailsCache[userId] && userDetailsCache[userId][brandId]) {
                    return userDetailsCache[userId][brandId];
                } else {
                    const userDetails = await TeamAPI.getTeamMembers(brandId, [userId]);
                    userDetailsCache[userId] = userDetailsCache[userId] || {};
                    userDetailsCache[userId][brandId] = userDetails && userDetails[0];
                    return userDetailsCache[userId][brandId];
                }
            } catch (err) {
                console.error(err);
            }
        };
    }
})();